(function () {
  const ratingEl = document.getElementById('kiyoh-rating');
  const countEl  = document.getElementById('kiyoh-count');

  // Als elementen niet bestaan, stop dan
  if (!ratingEl || !countEl) {
    return;
  }

  const KEY = 'kiyohData';
  const MAX_AGE = 24 * 60 * 60 * 1000; // 24 uur

  // Helper functie om data op te slaan en direct te tonen
  function updateDisplay(rating, count) {
    if (rating && count) {
      ratingEl.textContent = rating;
      countEl.textContent = count;
      localStorage.setItem(KEY, JSON.stringify({ rating, count, ts: Date.now() }));
    }
  }

  // Haal cache op
  let cached;
  try {
    cached = JSON.parse(localStorage.getItem(KEY) || '{}');
  } catch (_) {
    cached = {};
  }

  // ---- 1. TOON DIRECT CACHED DATA ALS BESCHIKBAAR ----
  if (cached.rating && cached.count) {
    ratingEl.textContent = cached.rating;
    countEl.textContent = cached.count;
  }

  // ---- 2. HAAL ALTIJD NIEUWE DATA OP (OP ACHTERGROND) ----
  // Functie om data op te halen en te updaten
  function fetchAndUpdate() {
    fetch('https://www.kiyoh.com/v1/review/feed.xml?hash=yvyhxobnoosp0jz')
      .then(r => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.text();
      })
      .then(str => {
        const parser = new DOMParser();
        const xml = parser.parseFromString(str, 'text/xml');
        
        // Check voor parse errors
        const parseError = xml.querySelector('parsererror');
        if (parseError) {
          throw new Error('XML parse error');
        }

        const rating = xml.querySelector('averageRating')?.textContent?.replace('.', ',');
        const count  = xml.querySelector('numberReviews')?.textContent;
        
        if (rating && count) {
          // DIRECT UPDATEN - niet wachten tot volgende paginalaad!
          updateDisplay(rating, count);
        } else {
          throw new Error('Rating of count niet gevonden in XML');
        }
      })
      .catch(err => {
        console.error('Kiyoh-feed ophalen mislukt:', err);
        // Als fetch mislukt EN er is geen cache, blijf fallback gebruiken
        // Anders blijft de cached waarde staan
      });
  }

  // Check of we direct moeten updaten (cache oud of ontbreekt)
  const needsImmediateUpdate = !cached.ts || Date.now() - cached.ts > MAX_AGE || !cached.rating || !cached.count;

  if (needsImmediateUpdate) {
    // Direct updaten als cache oud is of ontbreekt
    fetchAndUpdate();
  } else {
    // Cache is nog geldig, maar haal toch nieuwe data op op achtergrond
    // Dit zorgt ervoor dat de volgende keer de data al klaar staat
    // We gebruiken requestIdleCallback als beschikbaar, anders setTimeout
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fetchAndUpdate, { timeout: 5000 });
    } else {
      setTimeout(fetchAndUpdate, 2000);
    }
  }
})();